// Copyright (c) 2016 Deere & Company

import React, {PropTypes} from 'react';
import ActionLink from '../action-link';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';

function handleClick(selectedKey, pin) {

    this.onClick(selectedKey, pin);

}

const CreateClaimModalBody = props =>
    <div className='create-claim-modal-body'>
        <span className='create-claim-title'>
            <FormattedMessage id={'PLEASE_SELECT_CLAIM_TYPE'}/>
        </span>
        <ul>
            {
                props.claimTypes.map(claim => (
                    <li
                        key={claim.key}
                    >
                        <ActionLink
                            isDisabled={false}
                            label={claim.value}
                            onClick={handleClick.bind(props, claim.key, props.selectedPin)}
                            type={'button-link'}
                        />
                    </li>
                ))
            }
        </ul>
    </div>;

CreateClaimModalBody.displayName = 'CreateClaimModalBody';
CreateClaimModalBody.propTypes = {
    claimTypes: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    onClick: PropTypes.func.isRequired,
    selectedPin: PropTypes.string
};

export default CreateClaimModalBody;



// WEBPACK FOOTER //
// ./src/shared/components/create-claim-modal/create-claim-modal-body.js